import { useEffect, useState } from "react";
import { axiosInstance } from "./config";

export const useSupplierIndustries = () => {
  const [supplierIndustries, setSupplierIndustries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchSupplierIndustries = () => {
    setIsLoading(true);
    axiosInstance.get("supplier-industries").then((res) => {
      setSupplierIndustries(
        res.data?.map((data) => ({ value: data.id, label: data.name }))
      );
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchSupplierIndustries();
  }, []);

  return { isLoading, supplierIndustries, fetchSupplierIndustries };
};
